/** Coordena os convites (instalar/notificações) para nunca aparecerem dois ao mesmo tempo. */
import { useSyncExternalStore } from 'react';

export type PromptKind = 'install-screen' | 'installed-hint' | 'install-banner' | 'push' | 'whatsapp-phone';

let active: PromptKind | null = null;
const listeners = new Set<() => void>();
const emit = () => listeners.forEach((l) => l());

/** Tenta ocupar a vez. Retorna false se outro convite já está na tela. */
export function claimPrompt(kind: PromptKind): boolean {
  if (active && active !== kind) return false;
  if (active !== kind) { active = kind; emit(); }
  return true;
}

export function releasePrompt(kind: PromptKind) {
  if (active === kind) { active = null; emit(); }
}

export function getActivePrompt() { return active; }

export function useActivePrompt() {
  return useSyncExternalStore(
    (cb) => { listeners.add(cb); return () => listeners.delete(cb); },
    () => active,
    () => active,
  );
}
